import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    params: { type: Array, default: [] }
  }
  
  connect() {
    this.cleanUrl()
  }
  
  cleanUrl() {
    // Check if we need to clean any params
    if (this.paramsValue.length === 0) return
    
    const url = new URL(window.location)
    let shouldClean = false
    
    // Check if any of the specified params exist
    this.paramsValue.forEach(param => {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param)
        shouldClean = true
      }
    })
    
    // If we removed any params, update the URL without reloading
    if (shouldClean && window.history && window.history.replaceState) {
      const cleanUrl = url.pathname + (url.search || '')
      window.history.replaceState({}, document.title, cleanUrl)
    }
  }
}